// extracted by mini-css-extract-plugin
export default {"infos":"SeriesIndexOverviewInfo-infos-vITgD"};